import { render, staticRenderFns } from "./AccountGroup.vue?vue&type=template&id=fa2b1464"
import script from "./AccountGroup.vue?vue&type=script&lang=js"
export * from "./AccountGroup.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports